import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { getalumniFeedback, deletealumniFeedbacks } from '../../ReduxToolkit/Slice/Feedback/AlumniFeedback';


function AlumniFeedback() {
    const dispatch = useDispatch();
    const { status, alumniFeedbacks } = useSelector((state) => state.alumniFeedback);
    //  get
    useEffect(() => {
        if (status === "idle") {
            dispatch(getalumniFeedback())
        }
    }, [dispatch, status]);
    // delete api
    const handleDelete = (alumniFeedbackid) => {
        const Isconfirmed = window.confirm("Are you sure! you want delete this Feedback?")
        if (Isconfirmed) {
            dispatch(deletealumniFeedbacks(alumniFeedbackid))
        };
    }
    // single data fetch
    const [email, setEmail] = useState(null);
    const [name, setName] = useState("");
    const [year, setYear] = useState("");
    const [programme, setProgramme] = useState("");
    const [batch, setBatch] = useState("");
    const [question1, setQuestion1] = useState("");
    const [question2, setQuestion2] = useState("");
    const [question3, setQuestion3] = useState("");
    const [question4, setQuestion4] = useState("");
    const [question5, setQuestion5] = useState("");
    const [question6, setQuestion6] = useState("");
    const [question7, setQuestion7] = useState("");
    const [question8, setQuestion8] = useState("");
    const [question9, setQuestion9] = useState("");
    const [question10, setQuestion10] = useState("");
    const [suggestion, setSuggestion] = useState("");

    const [selectedId, setSelectedId] = useState(null);
    const handlid = (id) => {
        const selectedalumniFeedback = alumniFeedbacks.data.find(alumniFeedback => alumniFeedback._id === id);
        setEmail(selectedalumniFeedback.email);
        setName(selectedalumniFeedback.name);
        setYear(selectedalumniFeedback.year);
        setProgramme(selectedalumniFeedback.programme);
        setBatch(selectedalumniFeedback.batch);
        setQuestion1(selectedalumniFeedback.question1);
        setQuestion2(selectedalumniFeedback.question2);
        setQuestion3(selectedalumniFeedback.question3);
        setQuestion4(selectedalumniFeedback.question4);
        setQuestion5(selectedalumniFeedback.question5);
        setQuestion6(selectedalumniFeedback.question6);
        setQuestion7(selectedalumniFeedback.question7);
        setQuestion8(selectedalumniFeedback.question8);
        setQuestion9(selectedalumniFeedback.question9);
        setQuestion10(selectedalumniFeedback.question10);
        setSuggestion(selectedalumniFeedback.suggestion);
        setSelectedId(id);
    };
    return (
        <>
            <div>
                <div className='d-flex justify-content-between my-3'>
                    <h3>Alumni Feedbacks </h3>
                </div>
                <div className='table-responsive'>
                    <table className="table table-hover">
                        <thead className="table-primary">
                            <tr>
                                <th scope="col">S.no</th>
                                <th scope="col">Name</th>
                                <th scope="col">Email</th>
                                <th scope="col">Programme</th>
                                <th scope="col">Batch</th>
                                <th scope="col">Year</th>
                                <th scope="col">date</th>

                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {status === "loading" && (
                                <tr className='my-2'>
                                    <td colSpan={8}>
                                        <Skeleton count={10} height={90} />
                                    </td>
                                </tr>
                            )}
                            {status === "failed" && (
                                <tr>
                                    <td colSpan={8}>
                                        <p className='text-center fw-bold'>{"Data not found"}</p>
                                    </td>
                                </tr>
                            )}
                            {status === "succeeded" && alumniFeedbacks.data && alumniFeedbacks.data.map((alumniFeedback, index) => {
                                const newdate = new Date(alumniFeedback.createdAt);
                                const formattedDate = newdate.toLocaleDateString("default", {
                                    day: "2-digit",
                                    month: "long",
                                    year: "numeric"
                                });
                                return (
                                    <tr key={alumniFeedback._id}>
                                        <th scope="row">{index + 1}</th>
                                        <td>{alumniFeedback.name}</td>
                                        <td>{alumniFeedback.email}</td>
                                        <td>{alumniFeedback.programme}</td>
                                        <td>{alumniFeedback.batch}</td>
                                        <td>{alumniFeedback.year}</td>
                                        <td>{formattedDate}</td>
                                        <td className='cursor'>
                                            <div onClick={() => handlid(alumniFeedback._id)}><i className='bi bi-eye-fill text-primary fs-5' data-bs-toggle="modal" data-bs-target="#exampleModal"></i></div>
                                            <div onClick={() => handleDelete(alumniFeedback._id)}><i className='bi bi-trash text-danger fs-5'></i></div>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Modal  */}
            <div
                className="modal fade"
                id="exampleModal"
                tabIndex={-1}
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-xl modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="exampleModalLabel">
                                alumni Feedback
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-12 col-lg-4 mb-3">
                                    <div>
                                        <h6>Name</h6>
                                        <h6 className='text-primary'>{name}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 mb-3">
                                    <div>
                                        <h6>Email</h6>
                                        <h6 className='text-primary'>{email}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 mb-3">
                                    <div>
                                        <h6>Programme</h6>
                                        <h6 className='text-primary'>{programme}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 mb-3">
                                    <div>
                                        <h6>Batch</h6>
                                        <h6 className='text-primary'>{batch}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 mb-3">
                                    <div>
                                        <h6>Year</h6>
                                        <h6 className='text-primary'>{year}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>1 .The curriculum prescribed for your degree during your term in the college was adequate.</h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{fontSize:"10px"}}></i> {question1}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>2 .The quality of education imparted in the college was effective for your job profile / employability.</h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{fontSize:"10px"}}></i> {question2}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>3 .The curriculum brings a balance between theory and practical learning.</h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{fontSize:"10px"}}></i> {question3}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>4 .The curriculum is well-structured to achieve the learning outcomes.</h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{fontSize:"10px"}}></i> {question4}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>5 .The curriculum fulfills your expectation in terms of professional growth/ excellence.</h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{fontSize:"10px"}}></i> {question5}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>6 .The curriculum fulfils the objectives of the program.</h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{fontSize:"10px"}}></i> {question6}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>7 .The curriculum addresses human values/ social values/ professional ethics etc.</h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{fontSize:"10px"}}></i> {question7}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>8 .The curriculum inculcates attributes like personality development/ professional skills, etc.</h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{fontSize:"10px"}}></i> {question8}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>9 .The curriculum is accessible to current trends and practices with respect to emerging needs of the society.</h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{fontSize:"10px"}}></i> {question9}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>10 .The curriculum facilitates overall holistic development.</h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{fontSize:"10px"}}></i> {question10}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 my-3 border rounded py-2">
                                    <div>
                                        <h6>SUGGESTIONS</h6>
                                         <p>{suggestion}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AlumniFeedback;
